import { getUniversalCookieValue, parseJsonSafely } from "@/utils/GlobalJavascriptFunction";
import { SECURE_COOKIE } from "@globalConfig";
import cookieClient from 'react-cookies';
var COOKIE_NAME = "inapp_source";
function getLocationParams(search) {
  return new URLSearchParams(search);
}
export default function getInAppSource(req) {
  if (__IS_SSR__ && req) {
    var search = req.originalUrl.includes('?') ? req.originalUrl.split('?')[1] : '';
    var _params = getLocationParams(search);
    var paramsData = parseJsonSafely(_params.get("inapp_source")) || null;
    return getUniversalCookieValue(req, COOKIE_NAME, paramsData);
  }
  if (typeof window === "undefined" || !window.location) {
    return null;
  }
  var params = getLocationParams(window.location.search);
  var inAppSource = parseJsonSafely(params.get("inapp_source")) || null;
  var cookieData = cookieClient.load(COOKIE_NAME);
  if (inAppSource) {
    cookieClient.save(COOKIE_NAME, JSON.stringify(inAppSource), {
      path: "/",
      maxAge: 3600 * 24 * 365 * 10,
      // Cookie will expire after 10 years
      sameSite: true,
      secure: SECURE_COOKIE
    });
  } else if (cookieData) {
    inAppSource = cookieData;
  }
  return inAppSource;
}